import { CareNeeds } from '../../../types/CareNeeds'
import { PRODUCT_WEB_DENTAL } from '../../../utils/consts'
import { WebQuote } from './buildWebOffer'

// TODO sort web quotes on step 1 and step show products

export default function sortWebQuotes(quotes: WebQuote[], careNeeds?: CareNeeds): WebQuote[] {
  const sortedOffers = quotes
    // Sort the offers by care value
    .sort((offer1, offer2) => offer2.product.careValue - offer1.product.careValue)

  // Put the dental care product first, except if the user doesn't need it
  if (careNeeds?.dentalCareValue === 'no') {
    return [
      ...sortedOffers.filter((offer) => offer.product.id !== PRODUCT_WEB_DENTAL.id),
      quotes.filter((offer) => offer.product.id === PRODUCT_WEB_DENTAL.id)[0],
    ]
  }

  return [
    quotes.filter((offer) => offer.product.id === PRODUCT_WEB_DENTAL.id)[0],
    ...sortedOffers.filter((offer) => offer.product.id !== PRODUCT_WEB_DENTAL.id),
  ]
}
